import BaseDynamicPage from "%/dynamic-component-editor/classes/base-dynamic-page";
import AuthorAvatar from "%/dynamic-component-editor/standard-pages/story-page/AuthorAvatar.vue";
import AuthorName from "%/dynamic-component-editor/standard-pages/story-page/AuthorName.vue";
import StoryTitle from "%/dynamic-component-editor/standard-pages/story-page/StoryTitle.vue";
import StoryImage from "%/dynamic-component-editor/standard-pages/story-page/StoryImage.vue";
import StoryMedia from "%/dynamic-component-editor/standard-pages/story-page/StoryMedia.vue";
import StoryCreated from "%/dynamic-component-editor/standard-pages/story-page/StoryCreated.vue";
import EstimatedReadingTime
  from "%/dynamic-component-editor/standard-pages/story-page/EstimatedReadingTime.vue";
import StoryContent from "%/dynamic-component-editor/standard-pages/story-page/StoryContent.vue";
import HashTags from "%/dynamic-component-editor/standard-pages/story-page/HashTags.vue";
import UpvoteAction from "%/dynamic-component-editor/standard-pages/story-page/UpvoteAction.vue";
import DownvoteAction from "%/dynamic-component-editor/standard-pages/story-page/DownvoteAction.vue";
import LikeAction from "%/dynamic-component-editor/standard-pages/story-page/LikeAction.vue";
import VoteScore from "%/dynamic-component-editor/standard-pages/story-page/VoteScore.vue";
import UpvoteScore from "%/dynamic-component-editor/standard-pages/story-page/UpvoteScore.vue";
import DownvoteScore from "%/dynamic-component-editor/standard-pages/story-page/DownvoteScore.vue";
import LikeCount from "%/dynamic-component-editor/standard-pages/story-page/LikeCount.vue";
import CommentCount from "%/dynamic-component-editor/standard-pages/story-page/CommentCount.vue";
import CommentsWidget from "%/dynamic-component-editor/standard-pages/story-page/CommentsWidget.vue";
import PublicationName from "%/dynamic-component-editor/standard-pages/story-page/PublicationName.vue";
import ShareButton from "%/dynamic-component-editor/standard-pages/story-page/ShareButton.vue";
import Comments from "%/dynamic-component-editor/standard-components/comments-widget/Comments.vue";
import CommentInput from "%/dynamic-component-editor/standard-elements/comments-widget/CommentInput.vue";
import SubmitCommentButton from "%/dynamic-component-editor/standard-components/comments-widget/SubmitCommentButton.vue";
import AddCommentButton from "%/dynamic-component-editor/standard-elements/comments-widget/AddCommentButton.vue";
import CancelCommentButton from "%/dynamic-component-editor/standard-elements/comments-widget/CancelCommentButton.vue";

export default class StoryPage extends BaseDynamicPage {

  // Page-specific overrides for elements that share their `name` with
  // the card variants registered by `LegacyStory.elements`. The DC's
  // `availableElementVueComponents` resolver lays the per-context
  // entity elements down first, then layers these on top (last write
  // wins). Without this, a Story Page surfaced `StoryContent` from
  // the base-story-card folder — a link rendering the truncated
  // `text` summary — instead of the full-body PlainStoryEditor preview
  // that lives here. Same problem for the other dual-named elements:
  // the page should render its richer in-place variant, not the card.
  static possibleElementVueComponents = [
    AuthorAvatar,
    AuthorName,
    StoryTitle,
    StoryImage,
    StoryMedia,
    StoryCreated,
    StoryContent,
    EstimatedReadingTime,
    HashTags,
    UpvoteAction,
    DownvoteAction,
    LikeAction,
    VoteScore,
    UpvoteScore,
    DownvoteScore,
    LikeCount,
    CommentCount,
    CommentsWidget,
    Comments,
    CommentInput,
    SubmitCommentButton,
    AddCommentButton,
    CancelCommentButton,
    PublicationName,
    ShareButton,
  ];
}

